export const carriersFilterFunction = (item, valuesToBeFilteredOn) => {
  // let flag = false;
  let oflag = false;
  let rflag = false;
  valuesToBeFilteredOn.forEach(value => {
    // if (value === 'multi') {
    //   if (item.valuesForSort.carrier === 'multi') {
    //     flag = true;
    //   }
    //   if (item.returnFlight && item.returnFlight.valuesForSort.carrier !== 'multi') {
    //     flag = false;
    //   }
    // }
    if (item.valuesForSort.carrier === value) {
      // flag = true;
      oflag = true;
    }
    // KEEP THIS IN MIND
    // if (item.returnFlight && item.returnFlight.valuesForSort.carrier !== value) {
    if (item.returnFlight && item.returnFlight.valuesForSort.carrier === value) {
      // flag = false;
      rflag = true;
    }
  });
  let flag = oflag;
  if (item.returnFlight) {
    flag = oflag && rflag;
  }
  return flag;
};

export const pureFilterFunction = (item, valuesToBeFilteredOn) => {
  return valuesToBeFilteredOn.some(value => {
    let oflag = !item.valuesForSort.isCodeShareFlight && item.valuesForSort.carrier === value;
    let rflag = true;
    if (item.returnFlight && item.returnFlight.valuesForSort.carrier !== value) {
      rflag = false;
    }
    return oflag && rflag;
  });
};

export const impureFilterFunction = (item, valuesToBeFilteredOn) => {
  return valuesToBeFilteredOn.some(value => {
    let oflag = item.flightArr.some(leg => leg.carrier.carrierIndex === value);
    let rflag = false;
    if (
      !oflag &&
      item.returnFlight &&
      item.returnFlight.flightArr.some(leg => leg.carrier.carrierIndex === value)
    ) {
      rflag = true;
    }
    return oflag || rflag;
  });
};

export const stopsFilterFunction = (itemObj, valuesToBeFilteredOn) => {
  let item = itemObj;
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case '0':
        if (item.flightArr.length === 1) {
          flag = true;
        }
        break;
      case '1':
        if (item.flightArr.length === 2) {
          flag = true;
        }
        break;
      case '2':
        if (item.flightArr.length >= 3) {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export const roundTripStopsFilterFunction = (itemObj, valuesToBeFilteredOn) => {
  let flag = false;
  const item = itemObj.returnFlight ? itemObj.returnFlight : itemObj;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case '0':
        if (item.flightArr.length === 1) {
          flag = true;
        }
        break;
      case '1':
        if (item.flightArr.length === 2) {
          flag = true;
        }
        break;
      case '2':
        if (item.flightArr.length >= 3) {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export const timePeriodFilterFunction = (itemObj, valuesToBeFilteredOn) => {
  let item = itemObj;
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case 'tp1':
        if (item.valuesForSort.departure < 600) {
          flag = true;
        }
        break;
      case 'tp2':
        if (item.valuesForSort.departure >= 600 && item.valuesForSort.departure < 1200) {
          flag = true;
        }
        break;
      case 'tp3':
        if (item.valuesForSort.departure >= 1200 && item.valuesForSort.departure < 1800) {
          flag = true;
        }
        break;
      case 'tp4':
        if (item.valuesForSort.departure >= 1800 && item.valuesForSort.departure < 2400) {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export const roundTripTimePeriodFilterFunction = (itemObj, valuesToBeFilteredOn) => {
  let flag = false;
  const item = itemObj.returnFlight ? itemObj.returnFlight : itemObj;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case 'tp1':
        if (item.valuesForSort.departure < 600) {
          flag = true;
        }
        break;
      case 'tp2':
        if (item.valuesForSort.departure >= 600 && item.valuesForSort.departure < 1200) {
          flag = true;
        }
        break;
      case 'tp3':
        if (item.valuesForSort.departure >= 1200 && item.valuesForSort.departure < 1800) {
          flag = true;
        }
        break;
      case 'tp4':
        if (item.valuesForSort.departure >= 1800 && item.valuesForSort.departure < 2400) {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export const refundabilityFilterFunction = (item, isRefundable) => {
  let flag = false;
  if (item.refundability !== 'Non-Refundable') {
    flag = true;
  } else {
    return flag;
  }
  if (item.returnFlight && item.returnFlight.refundability === 'Non-Refundable') {
    flag = false;
  }
  return flag;
};

export const hideMultiAirlineFilterFunction = item => {
  let flag = true;
  if (item.valuesForSort.multiCheckin) {
    flag = false;
  }
  return flag;
};

export const priceFilterFunction = (item, minMax) => {
  let flag = false;
  const price = parseInt(item.pricePerPerson.replace(/,/g, ''), 10);
  if (price >= minMax[0].min && price <= minMax[0].max) {
    flag = true;
  }

  return flag;
};

export const durationFilterFunction = (item, minMax) => {
  let flag = false;
  const duration = parseInt(item.duration.replace(/\D+/g, ''), 10);
  if (duration >= minMax[0].min && duration <= minMax[0].max) {
    flag = true;
  }

  return flag;
};

export const returnDurationFilterFunction = (itemObj, minMax) => {
  const item = itemObj.returnFlight ? itemObj.returnFlight : itemObj;
  let flag = false;
  const duration = parseInt(item.duration.replace(/\D+/g, ''), 10);
  if (duration >= minMax[0].min && duration <= minMax[0].max) {
    flag = true;
  }

  return flag;
};

export const layoverFilterFunction = (item, layoverAirport) => {
  let flag = false;
  const noOfFlights = item.flightArr.length;
  item.flightArr.forEach((flt, i) => {
    if (i < noOfFlights - 1 && layoverAirport.includes(flt.arrCode)) {
      flag = true;
    }
  });
  return flag;
};

export const destinationFilterFunction = (item, destinationAirport) => {
  let flag = false;
  const noOfFlights = item.flightArr.length;
  item.flightArr.forEach((flt, i) => {
    if (i === noOfFlights - 1 && destinationAirport.includes(flt.arrCode)) {
      flag = true;
    }
  });

  return flag;
};

export const returnSourceFilterFunction = (item, sourceAirport) => {
  let flag = false;
  let flight = item;
  if (item?.returnFlight) {
    flight = item.returnFlight;
  }
  const srcAirport = flight?.flightArr?.[0]?.depCode || '';
  if (srcAirport && sourceAirport.includes(srcAirport)) {
    flag = true;
  }
  return flag;
};

export const returnLayoverFilterFunction = (item, layoverAirport) => {
  let flag = false;
  const flight = item?.returnFlight;
  const noOfFlights = flight.flightArr.length;
  flight.flightArr.forEach((flt, i) => {
    if (i < noOfFlights - 1 && layoverAirport.includes(flt.arrCode)) {
      flag = true;
    }
  });
  return flag;
};

export const returnDestinationFilterFunction = (item, destinationAirport) => {
  let flag = false;
  const flight = item?.returnFlight;
  const noOfFlights = flight.flightArr.length;
  flight.flightArr.forEach((flt, i) => {
    if (i === noOfFlights - 1 && destinationAirport.includes(flt.arrCode)) {
      flag = true;
    }
  });

  return flag;
};

export const filterPreselectedFlight = (item, preselectedFlight) => {
  if (preselectedFlight) {
    return item?.originalIndex !== preselectedFlight?.originalIndex;
  }
  return true;
};

// city country
export const stopsFilterCityCountryFunction = (itemObj, valuesToBeFilteredOn) => {
  let item = itemObj;
  let flag = false;
  let minPrice = Infinity;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case '0':
        if ('minCostNonStopArray' in item) {
          const minCostNonStopArray = item?.minCostNonStopArray;
          for (let i = 0; i < minCostNonStopArray?.length; i++) {
            if (minCostNonStopArray[i].price < minPrice) {
              item.minCostStop = minCostNonStopArray[i];
              minPrice = minCostNonStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
      case '1':
        if ('minCostOneStopArray' in item) {
          const minCostOneStopArray = item?.minCostOneStopArray;
          for (let i = 0; i < minCostOneStopArray?.length; i++) {
            if (minCostOneStopArray[i].price < minPrice) {
              item.minCostStop = minCostOneStopArray[i];
              minPrice = minCostOneStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
      case '2':
        if ('minCostOnePlusStopArray' in item) {
          const minCostOnePlusStopArray = item?.minCostOnePlusStopArray;
          for (let i = 0; i < minCostOnePlusStopArray?.length; i++) {
            if (minCostOnePlusStopArray[i].price < minPrice) {
              item.minCostStop = minCostOnePlusStopArray[i];
              minPrice = minCostOnePlusStopArray[i].price;
              flag = true;
            }
          }
        }
        break;
    }
  });
  return flag;
};

export const priceFilterCityCountryFunction = (item, minMax) => {
  let flag = false;
  if (item.minCostStop.price >= minMax[0].min && item.minCostStop.price <= minMax[0].max) {
    flag = true;
  }
  return flag;
};

export const durationFilterCityCountryFunction = (item, minMax) => {
  let flag = false;
  if (
    parseInt(item?.minCostStop?.onwardFlightDurationInMins) +
      parseInt(item?.minCostStop?.returnFlightDurationInMins || 0) >=
      minMax[0].min &&
    parseInt(item?.minCostStop?.onwardFlightDurationInMins) +
      parseInt(item?.minCostStop?.returnFlightDurationInMins || 0) <=
      minMax[0].max
  ) {
    flag = true;
  }
  return flag;
};

export const famousForFilterFunction = (item, valuesToBeFilteredOn) => {
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    if (value === 'All' || (item.categories && item.categories.includes(value))) {
      flag = true;
    }
  });
  return flag;
};

export const showCountriesFilterFunction = (item, valuesToBeFilteredOn) => {
  let flag = false;
  valuesToBeFilteredOn.forEach(value => {
    switch (value) {
      case 'visa-on-arrival':
        if (item.visa === 'visa-on-arrival') {
          flag = true;
        }
        break;
      case 'e-visa':
        if (item.visa === 'e-visa') {
          flag = true;
        }
        break;
      case 'visa-free':
        if (item.visa === 'visa-free') {
          flag = true;
        }
        break;
    }
  });
  return flag;
};

export const defaultFilterSettings = filter => {
  if (!filter) return null;
  let defaultFilters = {};
  const { journey, common } = filter || {};
  if (Array.isArray(journey)) {
    const filterTypeObject = getFilterTypeObject(journey[0]);
    defaultFilters['onwardFilterSetting'] = filterTypeObject;
    defaultFilters['defaultOnWardFilterSetting'] = filterTypeObject;
    if (Array.isArray(journey[1])) {
      const filterTypeObject = getFilterTypeObject(journey[1]);
      defaultFilters['returnFilterSetting'] = filterTypeObject;
      defaultFilters['defaultReturnFilterSetting'] = filterTypeObject;
    }
  }
  const commonFilterObject = getFilterTypeObject(common);
  defaultFilters['commonFilterSetting'] = commonFilterObject;
  defaultFilters['defaultCommonFilterSetting'] = commonFilterObject;
  return defaultFilters;
};

const getFilterTypeObject = filterType => {
  if (Array.isArray(filterType) && filterType.length) {
    const filters = {};
    filterType.forEach(type => {
      if (type.hasOwnProperty('fi') && Array.isArray(type['choices'])) {
        filters[type['fi']] = new Array(type['choices'].length).fill(0);
      }
    });
    return filters;
  }
  return null;
};
